<rlst-modal header="Property Suggestion" (closeModal)="close()">
  <div class="content">
    <div *ngIf="!data.isMobile" class="table-wrap">
      <ag-grid-angular
        (gridReady)="onGridReady($event)"
        (selectionChanged)="onSelectionChanged($event)"
        [rowData]="rowData"
        [defaultColDef]="defaultColDef"
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
        class="ag-theme-balham"
        suppressDragLeaveHidesColumns="true"
        rowSelection="multiple"
        suppressRowClickSelection="true">
      </ag-grid-angular>
    </div>
    <div *ngIf="data.isMobile" class="h-100">
      <div class="selection-header w-100 d-flex justify-content-between align-items-center">
        <label class="custom-checkbox">
          <input type="checkbox"
                 class="custom-control-input checkbox-default"
                 [checked]="isAllRowsSelected()"
                 (change)="toggleAllRows($event.target['checked'])">
          <span class="custom-control-indicator"></span>
          <span class="custom-control-description">Select all</span>
        </label>
        <span>{{getCheckedRows().length}}/{{rowData.length}}</span>
      </div>
      <div class="scroll-section">
        <div *ngFor="let row of rowData" class="d-flex mobile-row">
          <label class="custom-checkbox">
            <input type="checkbox"
                   class="custom-control-input checkbox-default"
                   [checked]="row.isChecked"
                   (change)="toggleRow(row)">
            <span class="custom-control-indicator"></span>
          </label>
          <div class="row-info d-flex flex-column">
            <p class="mb-0"><span class="label">APN/Tax ID: </span> {{row.propertyData.APN}}</p>
            <p class="mb-0"><span class="label">Owner Name: </span> {{row.propertyData.OWNER_NAME_1 | titlecase}}</p>
            <p class="mb-0"><span class="label">Address: </span> {{row.propertyData | rlstAddress | titlecase}}</p>
            <p class="mb-0"><span class="label">City: </span> {{row.propertyData.PROPERTY_CITY_NAME | titlecase}}</p>
            <p class="mb-0"><span class="label">County, State: </span> {{row.propertyData | rlstCountyState}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="actions-panel actions-panel__shadow">
    <div class="flex-spacer"></div>
    <button (click)="close()" class="btn-custom btn-custom-outline-blue-dark cancel-button">Cancel</button>
    <button (click)="proceed()"
            class="btn-custom btn-custom-blue-dark"
            [disabled]="isProceedDisabled && !getCheckedRows().length">
      Proceed
    </button>
  </div>
</rlst-modal>
